<template>
  <div class="text-center w-full">
    <TbWordLogo class="inline-flex max-w-[12rem] pb-12" />
    <div class="pb-12">
      <TbIcon
        icon="check-circle"
        class="text-success text-8xl"
      />
    </div>
    <div>
      <div class="text-2xl text-primary font-bold pb-3">
        You’re all set! 🎉
      </div>
      <div class="pb-6">
        <span>
          Please click below to sign in
        </span>
      </div>
      <router-link :to="{ name: Pages.signIn }">
        <button
          class="btn btn-primary  w-full"
        >
          Sign In
        </button>
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { TbWordLogo, TbIcon } from '@/components/tasty_bistro';
import { Pages } from '@/router';

</script>
